import { create } from "zustand";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import useDailyReportFilterStore from "./useDailyReportFilterStore";

export const useDailyReportStore = create((set) => ({
  dailyEmployeeAttendance: [],
  punchInLocations: [],
  punchOutLocations: [],
  isFetchingDailyEmployeeAttendance: false,
  isFetchingDailyEmployeeAttendanceError: false,

  fetchDailyEmployeeAttendance: async (queryParams) => {
    set({ isFetchingDailyEmployeeAttendance: true });
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const dailyEmployeeAttendance = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetDailyEmployeeAttendance?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({ dailyEmployeeAttendance });
    } catch (error) {
      set({ isFetchingDailyEmployeeAttendanceError: error });
    } finally {
      set({ isFetchingDailyEmployeeAttendance: false });
    }
  },
  fetchPunchInLocations: async () => {
    try {
      const punchInLocationsResponse = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetPunchInLocation`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const punchInLocations = punchInLocationsResponse;

      set({ punchInLocations });
    } catch (error) {
      console.error("Error fetching Punch-In Locations:", error);
    }
  },
  fetchPunchOutLocations: async () => {
    try {
      const punchOutLocationsResponse = await apiCall({
        url: `${API_BASE_URL1}AttendanceReport/GetPunchOutLocation`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      const punchOutLocations = punchOutLocationsResponse

      set({ punchOutLocations });
    } catch (error) {
      console.error("Error fetching Punch-In Locations:", error);
    }
  },
}));
